import React from 'react';

var PrivacyContent = props => {
    return (
      <div className="main privacy-page center">
        <h1>Privacy Policy</h1>
        <p>The Walter M. Cunningham website uses a dynamic client to request data from the user in a local browser and send it directly to braintree. Therefore, The Foundation does not collect or store any information on their server. Contact and billing information is stored in braintree and accessible to Foundation administrators, but credit card information is obfuscated. For more information, see Braintree's Privacy Policy <a href="https://www.paypal.com/us/webapps/mpp/ua/privacy-full">here</a></p>
      </div>
    )
  };

export default PrivacyContent;



// WEBPACK FOOTER //
// ./src/components/PrivacyContent.js